<template>
  <div>
    <div class="dropzone" :class="{ hovered: hovered, disabled: disabled }" @dragover.prevent="dragOver" @dragenter.prevent
      @drop.prevent="handleDrop" @dragenter="dragEnter" @dragleave="dragLeave" :disabled="disabled">
      <div class="d-flex flex-column mb-4">
        <v-icon large color="primary" class="mb-4">mdi-file-upload</v-icon>
        <span>Drag and Drop file here or <span class="font-weight-bold cursor-pointer"
          :style="{ color: disabled ? '#C0C0C0' : '#007BFF', textDecoration: disabled ? 'none' : 'underline', cursor: disabled ? 'not-allowed' : 'pointer' }"
            @click="chooseFile">Choose File</span> (10 File Max)</span>
      </div>
      <input type="file" multiple ref="fileInput" style="display: none;" @change="handleFiles" :disabled="disabled"/>
    </div>
    <div class="my-4">
      <div class="d-flex justify-content-between mb-2">
        <span class="color-grey-1">Supported format: <span class="font-weight-bold">.JPG, .JPEG, .PNG, .DOC, .DOCX,
            .XLS, .XLSX, .PDF, .CSV, .PPTX, .PPT, .ZIP</span></span>
      </div>
      <span v-if="disabled" class="font-weight-bold" style="color: #F2994A;">You've reached the maximum upload limit of 10 files.</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['disabled'],
  data() {
    return {
      hovered: false,
    }
  },
  methods: {
    dragEnter(event) {
      if (!this.disabled) {
        event.preventDefault();
        this.hovered = true;
      }
    },
    dragOver(event) {
      if (!this.disabled) {
        event.preventDefault();
        this.hovered = true;
      }
    },
    dragLeave(event) {
      if (!this.disabled) {
        event.preventDefault();
        this.hovered = false;
      }
    },
    handleDrop(event) {
      if (!this.disabled) {
        this.hovered = false;
        const files = event.dataTransfer.files;
        this.$emit('files-dropped', files);
      }
    },
    chooseFile() {
      if (!this.disabled) {
        this.$refs.fileInput.click();
      }
    },
    handleFiles(event) {
      if (!this.disabled) {
        const files = event.target.files;
        this.$emit('files-selected', files);
      }
    }
  }
}
</script>

<style scoped>
.dropzone {
  min-height: 184px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  border: 2px dashed #D7D7D7;
  border-radius: 10px;
  background-color: #FFFFFF;
}

.dropzone.disabled {
  background-color: #F0F0F0;
  border: 2px dashed #C0C0C0;
  cursor: not-allowed;
}

.hovered {
  background-color: #EEEEEE !important;
  border: 2px dashed #007bff !important;
}
</style>
